import { Injectable } from '@angular/core';
import { NavigationExtras, Router, UrlTree } from '@angular/router';
import { RouterParams } from './router-params.service';

export interface ParamedNavigationExtras extends NavigationExtras {
  params: { [key: string]: any };
}

@Injectable()
export class RouterService {
  public constructor(
    private router: Router,
    private params: RouterParams
  ) {
  }

  public async navigateByUrl(url: string | UrlTree, extras: ParamedNavigationExtras = {params: {}}): Promise<boolean> {
    // console.log('navigate by', url);
    this.params.set(extras.params);
    delete extras.params;
    return this.router.navigateByUrl(url, extras);
  }
}
